export const StatesCountry = [
  // USA (id: 1)
  { id: 101, name: "Alabama", code: "AL", countryId: 1 },
  { id: 102, name: "Alaska", code: "AK", countryId: 1 },
  { id: 103, name: "Arizona", code: "AZ", countryId: 1 },
  { id: 104, name: "Arkansas", code: "AR", countryId: 1 },
  { id: 105, name: "California", code: "CA", countryId: 1 },
  { id: 106, name: "Colorado", code: "CO", countryId: 1 },
  { id: 107, name: "Connecticut", code: "CT", countryId: 1 },
  { id: 108, name: "Delaware", code: "DE", countryId: 1 },
  { id: 109, name: "Florida", code: "FL", countryId: 1 },
  { id: 110, name: "Georgia", code: "GA", countryId: 1 },
  { id: 111, name: "Hawaii", code: "HI", countryId: 1 },
  { id: 112, name: "Idaho", code: "ID", countryId: 1 },
  { id: 113, name: "Illinois", code: "IL", countryId: 1 },
  { id: 114, name: "Indiana", code: "IN", countryId: 1 },
  { id: 115, name: "Iowa", code: "IA", countryId: 1 },
  { id: 116, name: "Kansas", code: "KS", countryId: 1 },
  { id: 117, name: "Kentucky", code: "KY", countryId: 1 },
  { id: 118, name: "Louisiana", code: "LA", countryId: 1 },
  { id: 119, name: "Maine", code: "ME", countryId: 1 },
  { id: 120, name: "Maryland", code: "MD", countryId: 1 },
  { id: 121, name: "Massachusetts", code: "MA", countryId: 1 },
  { id: 122, name: "Michigan", code: "MI", countryId: 1 },
  { id: 123, name: "Minnesota", code: "MN", countryId: 1 },
  { id: 124, name: "Mississippi", code: "MS", countryId: 1 },
  { id: 125, name: "Missouri", code: "MO", countryId: 1 },
  { id: 126, name: "Montana", code: "MT", countryId: 1 },
  { id: 127, name: "Nebraska", code: "NE", countryId: 1 },
  { id: 128, name: "Nevada", code: "NV", countryId: 1 },
  { id: 129, name: "New Hampshire", code: "NH", countryId: 1 },
  { id: 130, name: "New Jersey", code: "NJ", countryId: 1 },
  { id: 131, name: "New Mexico", code: "NM", countryId: 1 },
  { id: 132, name: "New York", code: "NY", countryId: 1 },
  { id: 133, name: "North Carolina", code: "NC", countryId: 1 },
  { id: 134, name: "North Dakota", code: "ND", countryId: 1 },
  { id: 135, name: "Ohio", code: "OH", countryId: 1 },
  { id: 136, name: "Oklahoma", code: "OK", countryId: 1 },
  { id: 137, name: "Oregon", code: "OR", countryId: 1 },
  { id: 138, name: "Pennsylvania", code: "PA", countryId: 1 },
  { id: 139, name: "Rhode Island", code: "RI", countryId: 1 },
  { id: 140, name: "South Carolina", code: "SC", countryId: 1 },
  { id: 141, name: "South Dakota", code: "SD", countryId: 1 },
  { id: 142, name: "Tennessee", code: "TN", countryId: 1 },
  { id: 143, name: "Texas", code: "TX", countryId: 1 },
  { id: 144, name: "Utah", code: "UT", countryId: 1 },
  { id: 145, name: "Vermont", code: "VT", countryId: 1 },
  { id: 146, name: "Virginia", code: "VA", countryId: 1 },
  { id: 147, name: "Washington", code: "WA", countryId: 1 },
  { id: 148, name: "West Virginia", code: "WV", countryId: 1 },
  { id: 149, name: "Wisconsin", code: "WI", countryId: 1 },
  { id: 150, name: "Wyoming", code: "WY", countryId: 1 },
  { id: 151, name: "District of Columbia", code: "DC", countryId: 1 },

  // Canada (id: 2)
  { id: 201, name: "Alberta", code: "AB", countryId: 2 },
  { id: 202, name: "British Columbia", code: "BC", countryId: 2 },
  { id: 203, name: "Manitoba", code: "MB", countryId: 2 },
  { id: 204, name: "New Brunswick", code: "NB", countryId: 2 },
  { id: 205, name: "Newfoundland and Labrador", code: "NL", countryId: 2 },
  { id: 206, name: "Northwest Territories", code: "NT", countryId: 2 },
  { id: 207, name: "Nova Scotia", code: "NS", countryId: 2 },
  { id: 208, name: "Nunavut", code: "NU", countryId: 2 },
  { id: 209, name: "Ontario", code: "ON", countryId: 2 },
  { id: 210, name: "Prince Edward Island", code: "PE", countryId: 2 },
  { id: 211, name: "Quebec", code: "QC", countryId: 2 },
  { id: 212, name: "Saskatchewan", code: "SK", countryId: 2 },
  { id: 213, name: "Yukon", code: "YT", countryId: 2 },

  // Australia (id: 4)
  { id: 401, name: "Australian Capital Territory", code: "ACT", countryId: 4 },
  { id: 402, name: "New South Wales", code: "NSW", countryId: 4 },
  { id: 403, name: "Northern Territory", code: "NT", countryId: 4 },
  { id: 404, name: "Queensland", code: "QLD", countryId: 4 },
  { id: 405, name: "South Australia", code: "SA", countryId: 4 },
  { id: 406, name: "Tasmania", code: "TAS", countryId: 4 },
  { id: 407, name: "Victoria", code: "VIC", countryId: 4 },
  { id: 408, name: "Western Australia", code: "WA", countryId: 4 },

  // United Kingdom (id: 9)
  { id: 901, name: "England", code: "ENG", countryId: 9 },
  { id: 902, name: "Scotland", code: "SCT", countryId: 9 },
  { id: 903, name: "Wales", code: "WLS", countryId: 9 },
  { id: 904, name: "Northern Ireland", code: "NIR", countryId: 9 },

  // UAE (id: 8)
  { id: 801, name: "Abu Dhabi", code: "AZ", countryId: 8 },
  { id: 802, name: "Dubai", code: "DU", countryId: 8 },
  { id: 803, name: "Sharjah", code: "SH", countryId: 8 },
  { id: 804, name: "Ajman", code: "AJ", countryId: 8 },
  { id: 805, name: "Umm Al Quwain", code: "UQ", countryId: 8 },
  { id: 806, name: "Ras Al Khaimah", code: "RK", countryId: 8 },
  { id: 807, name: "Fujairah", code: "FU", countryId: 8 },
];

